function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 9.5,
  fill: "#FCB154",
  stroke: "#E6A462"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5 13l.93.93a.1.1 0 00.14 0l1.86-1.86a.1.1 0 01.14 0l1.86 1.86a.1.1 0 00.14 0l1.86-1.86a.1.1 0 01.14 0l1.86 1.86a.1.1 0 00.14 0L15 13M15 6l-3 1.364L15 9M5 6l3 1.364L5 9",
  stroke: "#000",
  strokeLinecap: "round"
});
function SvgEmojiPoor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none"
  }, props), _ref, _ref2);
}
export default SvgEmojiPoor;